import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  private API_PDF = '';

  private HEADERS_JSON = { 'Content-Type' : 'application/json'};

  constructor( private http: HttpClient) {
    this.API_PDF = environment.API_PDF;
  }

  generatePDF(html: string, title: string, filename: string) {
    return this.http.post(this.API_PDF,
      {
        html : html,
        title : title,
        filename : filename
      },
      {
        headers : this.HEADERS_JSON
      });
  }

  downloadFile(file: String) {
    return this.http.get(`${this.API_PDF}/download/${file}`, {
      responseType : 'blob'
    });
  }
}
